import { DataPoint } from '../../../types/data-point.js';
import { getGroupedDataPointsByCoordinate } from '../../../utils/group-by-threshold.js';

export const selectedToGroupedDataPoints = (
  selected: Map<string, DataPoint[]>,
) => {
  let dataPoints: DataPoint[][] = [];
  selected.forEach((value, key) => {
    dataPoints = dataPoints.concat(
      getGroupedDataPointsByCoordinate(value, 'y'),
    );
  });
  return dataPoints;
};
